import React, { useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const SOCIAL_PLATFORMS = {
  facebook: {
    name: 'Facebook',
    color: 'rgb(66, 103, 178)',
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    )
  },
  instagram: {
    name: 'Instagram',
    color: 'rgb(225, 48, 108)',
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.897 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.897-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/>
      </svg>
    )
  },
  tiktok: {
    name: 'TikTok',
    color: 'rgb(45, 45, 45)',
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
      </svg>
    )
  }
};

// Données de démonstration - À remplacer par les vraies données de l'API
const DEMO_DATA = {
  facebook: {
    followers: 12500,
    engagement: 850,
    reach: 25000,
    growth: 5.2,
    posts: [
      { date: '2025-02-01', engagement: 780 },
      { date: '2025-02-02', engagement: 820 },
      { date: '2025-02-03', engagement: 890 },
      { date: '2025-02-04', engagement: 850 },
      { date: '2025-02-05', engagement: 920 },
      { date: '2025-02-06', engagement: 880 },
      { date: '2025-02-07', engagement: 850 }
    ]
  },
  instagram: {
    followers: 8900,
    engagement: 620,
    reach: 18000,
    growth: 7.8,
    posts: [
      { date: '2025-02-01', engagement: 580 },
      { date: '2025-02-02', engagement: 610 },
      { date: '2025-02-03', engagement: 590 },
      { date: '2025-02-04', engagement: 640 },
      { date: '2025-02-05', engagement: 620 },
      { date: '2025-02-06', engagement: 670 },
      { date: '2025-02-07', engagement: 620 }
    ]
  },
  tiktok: {
    followers: 5600,
    engagement: 980,
    reach: 35000,
    growth: 12.5,
    posts: [
      { date: '2025-02-01', engagement: 920 },
      { date: '2025-02-02', engagement: 950 },
      { date: '2025-02-03', engagement: 980 },
      { date: '2025-02-04', engagement: 1020 },
      { date: '2025-02-05', engagement: 990 },
      { date: '2025-02-06', engagement: 1050 },
      { date: '2025-02-07', engagement: 980 }
    ]
  }
};

const SocialMedia = () => {
  const [selectedPlatform, setSelectedPlatform] = useState('facebook');

  // Données du graphique pour la plateforme sélectionnée
  const chartData = {
    labels: DEMO_DATA[selectedPlatform].posts.map(post => 
      new Date(post.date).toLocaleDateString('fr-DZ', { day: 'numeric', month: 'short' })
    ),
    datasets: [
      {
        label: 'Engagement',
        data: DEMO_DATA[selectedPlatform].posts.map(post => post.engagement),
        borderColor: SOCIAL_PLATFORMS[selectedPlatform].color,
        backgroundColor: `${SOCIAL_PLATFORMS[selectedPlatform].color}33`,
        fill: true,
        tension: 0.4
      }
    ]
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: (context) => `Engagement: ${context.raw}`
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 200
        }
      }
    }
  };

  // Calculer le meilleur moment pour poster
  const getBestTimeToPost = () => {
    const posts = DEMO_DATA[selectedPlatform].posts;
    const maxEngagement = Math.max(...posts.map(post => post.engagement));
    const bestPost = posts.find(post => post.engagement === maxEngagement);
    return new Date(bestPost.date).toLocaleDateString('fr-DZ', { 
      weekday: 'long',
      hour: 'numeric'
    });
  };

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-6">Réseaux sociaux</h3>

        {/* Sélection de la plateforme */}
        <div className="flex space-x-4 mb-6">
          {Object.entries(SOCIAL_PLATFORMS).map(([key, platform]) => (
            <button
              key={key}
              onClick={() => setSelectedPlatform(key)}
              className={`flex items-center px-4 py-2 rounded-lg transition-colors ${
                selectedPlatform === key
                  ? 'bg-gray-100 text-gray-900'
                  : 'text-gray-500 hover:bg-gray-50'
              }`}
            >
              <span className="mr-2" style={{ color: platform.color }}>
                {platform.icon}
              </span>
              {platform.name}
            </button>
          ))}
        </div>

        {/* Statistiques */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
          <div className="bg-gray-50 rounded-lg p-4">
            <h4 className="text-sm font-medium text-gray-500 mb-1">Abonnés</h4>
            <p className="text-2xl font-semibold text-gray-900">
              {DEMO_DATA[selectedPlatform].followers.toLocaleString()}
            </p>
            <p className="text-sm text-green-600 mt-1">
              +{DEMO_DATA[selectedPlatform].growth}% ce mois
            </p>
          </div>

          <div className="bg-gray-50 rounded-lg p-4">
            <h4 className="text-sm font-medium text-gray-500 mb-1">Engagement</h4>
            <p className="text-2xl font-semibold text-gray-900">
              {DEMO_DATA[selectedPlatform].engagement.toLocaleString()}
            </p>
            <p className="text-sm text-gray-500 mt-1">
              interactions/jour
            </p>
          </div>

          <div className="bg-gray-50 rounded-lg p-4">
            <h4 className="text-sm font-medium text-gray-500 mb-1">Portée</h4>
            <p className="text-2xl font-semibold text-gray-900">
              {DEMO_DATA[selectedPlatform].reach.toLocaleString()}
            </p>
            <p className="text-sm text-gray-500 mt-1">
              personnes touchées
            </p>
          </div>

          <div className="bg-gray-50 rounded-lg p-4">
            <h4 className="text-sm font-medium text-gray-500 mb-1">Meilleur moment</h4>
            <p className="text-2xl font-semibold text-gray-900">
              {getBestTimeToPost()}
            </p>
            <p className="text-sm text-gray-500 mt-1">
              pour publier
            </p>
          </div>
        </div>

        {/* Graphique d'engagement */}
        <div className="mb-6">
          <h4 className="text-sm font-medium text-gray-700 mb-4">Évolution de l'engagement</h4>
          <div className="h-64">
            <Line data={chartData} options={chartOptions} />
          </div>
        </div>

        {/* Actions recommandées */}
        <div className="bg-gray-50 rounded-lg p-4">
          <h4 className="text-sm font-medium text-gray-900 mb-3">Actions recommandées</h4>
          <ul className="space-y-2 text-sm text-gray-600">
            {DEMO_DATA[selectedPlatform].engagement < 800 && (
              <li className="flex items-start">
                <svg className="h-5 w-5 text-blue-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122" />
                </svg>
                Augmenter la fréquence de publication
              </li>
            )}
            {DEMO_DATA[selectedPlatform].growth < 10 && (
              <li className="flex items-start">
                <svg className="h-5 w-5 text-blue-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
                </svg>
                Lancer une campagne de promotion
              </li>
            )}
            <li className="flex items-start">
              <svg className="h-5 w-5 text-blue-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Planifier les publications pour {getBestTimeToPost()}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SocialMedia;
